<template>
  <v-navigation-drawer
    app
    v-model="drawer"
    :mini-variant.sync="miniVariant"
    :color="color"
    :src="bg"
    :dark="dark"
    width="180"
  >
    <v-list dense nav class="py-0">
      <v-list-item two-line :class="miniVariant && 'px-0'">
        <v-list-item-content>
          <v-list-item-title>Adapt</v-list-item-title>
          <v-list-item-subtitle>By Codelevel</v-list-item-subtitle>
          <v-list-item-subtitle>v.1.1</v-list-item-subtitle>
        </v-list-item-content>
        <v-btn icon @click.stop="miniVariant = !miniVariant">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item v-for="item in items" :key="item.title" :to="item.to" link>
        <v-list-item-icon>
          <v-badge
            v-if="item.badge == true"
            color="info"
            icon="mdi-lightbulb-on"           
            overlap
          ></v-badge>
          <v-icon color="">{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <template>
      <!-- <Logout v-slot:append></Logout> -->
      <Logout v-slot:></Logout>
    </template>
  </v-navigation-drawer>
</template>

<script>
import Logout from "./Logout";

export default {
  components: {
    Logout,
  },
  data: () => ({
    drawer: true,
    color: "#34a95a",
    miniVariant: true,
    dark: true,
    expandOnHover: false,
    background: false,
    items: [
      { title: "Painel", icon: "mdi-chart-bar", to: "/painel", badge: true },

      {
        title: "Orçamentos",
        icon: "mdi-file-multiple-outline",
        to: "/orcamentos",
        badge: false,
      },
      {
        title: "Orçamento",
        icon: "mdi-file-eye-outline",
        to: "/orcamento",
        badge: false,
      },
      {
        title: "Requisições",
        icon: "mdi-monitor-multiple",
        to: "/requisicoes",
        badge: false,
      },
      {
        title: "Requisição",
        icon: "mdi-monitor-eye",
        to: "/requisicao",
        badge: false,
      },
      { title: "Usuários", icon: "mdi-account", to: "/usuarios", badge: false },
    ],
  }),
  methods: {
    users() {
      this.$router.push({ path: "/about" });
    },
  },
  computed: {
    bg() {
      return this.background
        ? "https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg"
        : undefined;
    },
  },
};
</script>

<style>
</style>